<template>
    <div id="weekly" @mouseup="selectChange">
        <div class="editor_wrapper">
            <quillEditorVue ref="quillEditor" content=""></quillEditorVue>
        </div>
        <div class="selection_menu" v-show="menuShow" :style="{'left':siteX+'px','top':siteY+'px'}">
            <div class="menu_btn" @click="setFont"><img src="./img/img_icon_03.png" alt="">扩写</div>
            <div class="menu_btn"><img src="./img/img_icon_04.png" alt="">改写</div>
            <div class="menu_btn"><img src="./img/img_icon_03.png" alt="">简写</div>
            <div class="menu_btn"><img src="./img/img_icon_07.png" alt="">续写</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import quillEditorVue from "COMPONENTS/QuillEditor.vue"
    export default {
        components:{quillEditorVue},
        data() {
            return {
                menuShow:false,
                siteX:0,
                siteY:0
            }
        },
        created() {
            
        },
        methods: {
            setFont(){
                this.$refs.quillEditor.quillEl.format('bold',true);
            },
            selectChange(e){
                let quill = this.$refs.quillEditor.quillEl;
                let range = quill.getSelection(true)
                if(range.length){
                    let x = 0,y = 0;
                    if(window.getSelection){//ie不支持
                        let userSelection = window.getSelection();
                        let oRange = userSelection.getRangeAt(0); //get the text range 
                        let oRect = oRange.getBoundingClientRect(); 
                        x = oRect.left;
                        y = oRect.top;
                    }else{
                        x = e.clientX;
                        y = e.clientY;
                    }
                    let cw = document.body.clientWidth;
                    if(x + 320 > cw - 20){
                        x = cw - 20 - 320;
                    }
                    console.log(x,y)
                    this.siteX = x;
                    this.siteY = y-36;

                    this.menuShow = true;
                }else{
                    this.menuShow = false;
                }
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #weekly{
        .selection_menu{
            position: fixed;
            width: 320px;
            height: 32px;
            display: flex;
            border: 1px solid #ccc;
            box-shadow: 0 0 10px 3px #ddd;
            border-radius: 8px;
            display: flex;
            background-color: #fff;
            .menu_btn{
                flex-grow: 1;
                width: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                cursor: pointer;
                &:not(:last-child){
                    border-right: 1px solid #ccc;
                }
                img{
                    display: block;
                    margin-right: 4px;
                    width: 18px;
                }
            }
        }
    }
</style>